var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container-sm mt-6" },
    [
      !_vm.clienteModal
        ? _c(
            "ConditionalTeleport",
            { attrs: { to: "page-header-actions", routes: _vm.moduleRoutes } },
            [
              _c("BasePageHeader", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "actions",
                      fn: function() {
                        return [
                          _c("BaseSplitButton", {
                            attrs: {
                              label: "Selecionar outra simulação",
                              items: _vm.headerMenuActions
                            },
                            on: {
                              click: _vm.openSearchHistory,
                              select: _vm.onHeaderAction
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1982524114
                )
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.clienteAtual.name
        ? _c("FeedbackWrapper", {
            attrs: {
              bordered: "",
              "no-data": true,
              message: "Selecione um cliente para simular",
              "min-height": 360
            }
          })
        : _vm.carregando
        ? _c(
            "div",
            {
              staticClass:
                "row justify-content-center mt-n3 simulador-analise__skeleton"
            },
            [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered" },
                  [_c("BaseLoadingSkeleton", { attrs: { height: "56px" } })],
                  1
                )
              ]),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [_c("BaseLoadingSkeleton", { attrs: { height: "220px" } })],
                  1
                )
              ]),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [_c("BaseLoadingSkeleton", { attrs: { height: "220px" } })],
                  1
                )
              ]),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered" },
                  [_c("BaseLoadingSkeleton", { attrs: { height: "320px" } })],
                  1
                )
              ])
            ]
          )
        : !_vm.simulacao.hash_code
        ? _c("FeedbackWrapper", {
            attrs: {
              bordered: "",
              "no-data": true,
              message: "Selecione uma simulação",
              "min-height": 360
            },
            scopedSlots: _vm._u([
              {
                key: "button",
                fn: function() {
                  return [
                    _c(
                      "BaseButton",
                      {
                        attrs: { dark: "", outline: "" },
                        on: { click: _vm.openSearchHistory }
                      },
                      [_vm._v(" Selecionar simulação ")]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        : _c(
            "div",
            { staticClass: "row justify-content-center mt-n3" },
            [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "az-card-bordered d-flex align-center",
                    staticStyle: { "max-width": "100%" }
                  },
                  [
                    _c(
                      "v-edit-dialog",
                      {
                        attrs: {
                          "return-value": _vm.simulacao.nome_simulacao,
                          large: "",
                          "cancel-text": "Cancelar",
                          "save-text": "Salvar"
                        },
                        on: {
                          "update:returnValue": function($event) {
                            return _vm.$set(
                              _vm.simulacao,
                              "nome_simulacao",
                              $event
                            )
                          },
                          "update:return-value": function($event) {
                            return _vm.$set(
                              _vm.simulacao,
                              "nome_simulacao",
                              $event
                            )
                          },
                          save: _vm.salvarNomeSimulacao
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "input",
                            fn: function() {
                              return [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    "hide-details": "",
                                    label: "Simulação"
                                  },
                                  model: {
                                    value: _vm.simulacao.nome_simulacao,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.simulacao,
                                        "nome_simulacao",
                                        $$v
                                      )
                                    },
                                    expression: "simulacao.nome_simulacao"
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _c(
                          "span",
                          {
                            ref: "nomeSpan",
                            staticClass:
                              "az-ds-card-title simulador-analise__nome"
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.simulacao.nome_simulacao) + " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c("v-spacer"),
                    _c("BaseSplitButton", {
                      attrs: {
                        label: "Editar nome",
                        items: _vm.cardMenuActions
                      },
                      on: { click: _vm.openEditNome, select: _vm.onCardAction }
                    })
                  ],
                  1
                )
              ]),
              _vm.simulationError
                ? _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "BaseAlert",
                        {
                          attrs: { icon: "warning", iconColor: "warning" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button",
                                fn: function() {
                                  return [
                                    _vm.restricoes_simulacao.tipo_simulador
                                      ? _c(
                                          "BaseButton",
                                          {
                                            staticClass: "mx-10",
                                            attrs: {
                                              small: "",
                                              dark: "",
                                              outline: "",
                                              "min-width": "80px"
                                            },
                                            on: { click: _vm.toRestricoes }
                                          },
                                          [_vm._v(" Alterar restrições ")]
                                        )
                                      : _vm._e()
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2344788789
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.simulationError) + " ")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.alertMessages.length
                ? _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "BaseAlert",
                        { attrs: { icon: "info", iconColor: "info" } },
                        _vm._l(_vm.alertMessages, function(m) {
                          return _c("span", {
                            key: m,
                            domProps: { innerHTML: _vm._s(m) }
                          })
                        }),
                        0
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center mb-10" },
                      [
                        _c("span", { staticClass: "az-ds-card-title" }, [
                          _vm._v(" Backtest ")
                        ]),
                        _c("v-spacer"),
                        _c(
                          "BaseModal",
                          {
                            staticClass: "d-inline",
                            attrs: {
                              "max-width": "80%",
                              "destroy-on-close": true,
                              height: "600px"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "button",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-center",
                                        on: { click: _vm.abrirModal }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "az-text-small az-muted mr-1"
                                          },
                                          [_vm._v(" Ampliar ")]
                                        ),
                                        _c("icon-svg", {
                                          attrs: {
                                            name: "mdi-fullscreen",
                                            color: "#8E8E8E",
                                            size: 16
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("Title", {
                                  attrs: { title: "Backtest simulada" }
                                }),
                                _c("line-chart", {
                                  ref: "rentabilidade2",
                                  attrs: {
                                    "chart-data": _vm.lineDataSimulacao,
                                    options: _vm.lineOptions,
                                    styles: { height: "80vh", width: "100%" }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("line-chart", {
                      ref: "rentabilidade",
                      attrs: {
                        "chart-data": _vm.lineDataSimulacao,
                        options: _vm.lineOptions
                      }
                    }),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("v-spacer"),
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              top: "",
                              "offset-y": "",
                              "close-on-content-click": false
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "d-flex align-center"
                                          },
                                          "div",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "az-text-small az-muted mr-2"
                                          },
                                          [_vm._v(" Visualizar benchmarks: ")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "elevation-0",
                                            attrs: {
                                              fab: "",
                                              "x-small": "",
                                              color: "primary"
                                            }
                                          },
                                          [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: "mdi-plus",
                                                color: "#FFFFFF",
                                                size: 16
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "bg-white p-5",
                                staticStyle: {
                                  "border-radius": "6px",
                                  width: "200px",
                                  "max-height": "320px",
                                  "overflow-y": "auto"
                                }
                              },
                              _vm._l(_vm.BENCHMARKS, function(bench) {
                                return _c("v-checkbox", {
                                  key: bench.id,
                                  attrs: {
                                    label: bench.nome,
                                    value: bench.id,
                                    color: "primary",
                                    dense: "",
                                    "hide-details": ""
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.benchmark_graph_changed = true
                                    }
                                  },
                                  model: {
                                    value: _vm.benchmarks_selecionados_grafico,
                                    callback: function($$v) {
                                      _vm.benchmarks_selecionados_grafico = $$v
                                    },
                                    expression:
                                      "benchmarks_selecionados_grafico"
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-6" }, [
                _c("div", { staticClass: "az-card-bordered h-100" }, [
                  _c("span", { staticClass: "az-ds-card-title" }, [
                    _vm._v(" Política de investimento simulada ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "mt-10" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-baseline" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "az-text-primary font-semibold mb-1"
                            },
                            [_vm._v(" Perfil de Risco ")]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              staticClass: "ml-2",
                              attrs: { right: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "span",
                                        _vm._g({}, on),
                                        [
                                          _c("icon-svg", {
                                            attrs: {
                                              name: "info-circle",
                                              color: "secondary",
                                              size: 16
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "max-width": "300px" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " Para possibilitar a comparação de portfolios com horizontes diferentes, anualizamos as estatísticas dos mesmos, ou seja, passamos o retorno e a volatilidade para um valor anual equivalente. "
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "span",
                          { staticClass: "col-8 az-text-secondary az-size-14" },
                          [_vm._v(" Perfil de Risco ")]
                        ),
                        _c(
                          "span",
                          { staticClass: "col-4 az-text-secondary az-size-14" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.restricoes_simulacao.perfil ||
                                    "Desconhecido"
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12 py-0" },
                          [_c("v-divider")],
                          1
                        ),
                        _c(
                          "span",
                          { staticClass: "col-8 az-text-secondary az-size-14" },
                          [_vm._v(" Retorno Esperado (% CDI anualizado) ")]
                        ),
                        _c(
                          "span",
                          { staticClass: "col-4 az-text-secondary az-size-14" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.toPercent(
                                    _vm.estatisticas.coef_cdi * 100 || 0
                                  )
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12 py-0" },
                          [_c("v-divider")],
                          1
                        ),
                        _c(
                          "span",
                          { staticClass: "col-8 az-text-secondary az-size-14" },
                          [_vm._v(" Volatilidade Esperada (anualizada) ")]
                        ),
                        _c(
                          "span",
                          { staticClass: "col-4 az-text-secondary az-size-14" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.toPercent(_vm.estatisticas.vol * 100 || 0)
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12 py-0" },
                          [_c("v-divider")],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "20px" } },
                    [
                      _c(
                        "p",
                        { staticClass: "az-text-primary font-semibold mb-1" },
                        [_vm._v("Cenários")]
                      ),
                      _c("v-divider"),
                      _c("v-simple-table", {
                        staticClass: "cenarios",
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th"),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: {
                                          "border-bottom-width": "2px"
                                        },
                                        attrs: { colspan: "3" }
                                      },
                                      [
                                        _vm._v(
                                          " Retornos (% CDI anualizado) por cenário "
                                        )
                                      ]
                                    ),
                                    _c("th")
                                  ]),
                                  _c("tr", [
                                    _c("th"),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: {
                                          "border-left-width": "2px"
                                        }
                                      },
                                      [_vm._v(" Pessimista ")]
                                    ),
                                    _c("th", { staticClass: "text-center" }, [
                                      _vm._v(" Base")
                                    ]),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: {
                                          "border-right-width": "2px"
                                        }
                                      },
                                      [_vm._v(" Otimista ")]
                                    ),
                                    _c("th", { staticClass: "text-center" }, [
                                      _vm._v(" Vol (%) "),
                                      _c("br"),
                                      _vm._v(" esperada ")
                                    ])
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  [
                                    _c("tr", { staticClass: "text-bold" }, [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-left",
                                          staticStyle: {
                                            "border-top-width": "2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.toTitleCase(_vm.modo)
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            "border-top-width": "2px",
                                            "border-left-width": "2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.cenario_portfolio
                                                  .pessimistic_scenario
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            "border-top-width": "2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.cenario_portfolio
                                                  .base_scenario
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            "border-top-width": "2px",
                                            "border-right-width": "2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.cenario_portfolio
                                                  .optimistic_scenario
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            "border-top-width": "2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.cenario_portfolio
                                                  .expected_volatility
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._l(_vm.cenarios, function(c) {
                                      return !["portfolio", "caixa"].includes(
                                        c.classe.toLowerCase()
                                      )
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              { staticClass: "text-left" },
                                              [_vm._v(_vm._s(c.classe))]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  "border-bottom-width": "2px",
                                                  "border-left-width": "2px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      c.pessimistic_scenario
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  "border-bottom-width": "2px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(c.base_scenario) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  "border-bottom-width": "2px",
                                                  "border-right-width": "2px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      c.optimistic_scenario
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c("td", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(c.expected_volatility)
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    })
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _c("span", { staticClass: "az-text-small" }, [
                        _vm._v(
                          " *Ativos fixados da posição e que não possuem as informações completas no consolidador, não são considerados nessa estatística "
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "20px" } },
                    [
                      _c(
                        "p",
                        { staticClass: "az-text-primary font-semibold mb-1" },
                        [_vm._v("Horizonte de Análise")]
                      ),
                      _c("v-divider"),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "span",
                          { staticClass: "col-8 az-text-secondary az-size-14" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.backtest.portfolio
                                    ? _vm.backtest.portfolio.data[0] || "-"
                                    : "-"
                                ) +
                                " " +
                                _vm._s(
                                  _vm.backtest.portfolio &&
                                    _vm.backtest.portfolio.data.length > 0
                                    ? " a " +
                                        _vm.backtest.portfolio.data[
                                          _vm.backtest.portfolio.data.length - 1
                                        ] || ""
                                    : ""
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "span",
                          { staticClass: "col-4 az-text-secondary az-size-14" },
                          [_vm._v(_vm._s(_vm.horizonteDiff))]
                        )
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "az-card-bordered print-only print-break-before d-flex justify-content-center h-100",
                    staticStyle: { "flex-direction": "column" }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "az-ds-card-title d-block mb-10" },
                      [_vm._v(" Composição estratégica ")]
                    ),
                    _c("ShowComposition", {
                      attrs: {
                        values: _vm.compEstr,
                        size: 0,
                        chartShowMoney: "",
                        "center-text": ""
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "az-card-bordered print-only print-break-before d-flex flex-column justify-content-center h-100"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "az-ds-card-title d-block mb-10" },
                      [_vm._v(" Liquidez portfólio simulado ")]
                    ),
                    _vm.liquidez.length
                      ? _c("ShowLiquidez", {
                          attrs: { values: _vm.liquidez, size: 0 }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "az-card-bordered print-only print-break-before"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "az-ds-card-title d-block mb-10" },
                      [_vm._v(" Estatística portfólio simulado ")]
                    ),
                    _c("TabelaRentBenchmark", {
                      attrs: { "rentabilidades-all": _vm.estatistica_portfolio }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "az-card-bordered print-only print-break-before"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "az-ds-card-title d-block mb-10" },
                      [_vm._v(" Evolução mensal ")]
                    ),
                    _c("TabelaRetornoMensais", {
                      attrs: { "retorno-mensal": _vm.retorno_mensal }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center mb-10" },
                      [
                        _c("span", { staticClass: "az-ds-card-title" }, [
                          _vm._v(" Carteira simulada ")
                        ]),
                        _c("v-spacer"),
                        _c("div", { staticClass: "text-right" }, [
                          _c(
                            "span",
                            { staticClass: "az-text-small az-muted d-block" },
                            [_vm._v(" P/L: ")]
                          ),
                          _c(
                            "span",
                            { staticClass: "az-text-primary font-semibold" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.toMoney(_vm.pl_total)) + " "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    ),
                    _c("SimulatorPortfolioTable", {
                      attrs: {
                        headers: _vm.headerCarteiraSimulada,
                        items: _vm.ativos,
                        "group-by": _vm.modo,
                        "fixed-assets": _vm.novosAtivos
                      },
                      on: {
                        "save-notes": _vm.handleSaveNotes,
                        "block-asset": _vm.bloquearAtivo,
                        "change-asset": _vm.trocarAtivo,
                        "fix-asset": _vm.fixarAtivo
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center mb-10" },
                      [
                        _c("span", { staticClass: "az-ds-card-title" }, [
                          _vm._v(" Operações ")
                        ]),
                        _c("v-spacer"),
                        _c("div", { staticClass: "text-right" }, [
                          _c(
                            "span",
                            { staticClass: "az-text-small az-muted d-block" },
                            [_vm._v(" Aportes: ")]
                          ),
                          _c(
                            "span",
                            { staticClass: "az-text-primary font-semibold" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.sumPL(
                                      _vm.operacoes.filter(function(a) {
                                        return a.operacao === "C"
                                      }),
                                      "movimentacao"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "ml-10 text-right" }, [
                          _c(
                            "span",
                            { staticClass: "az-text-small az-muted d-block" },
                            [_vm._v(" Resgates: ")]
                          ),
                          _c(
                            "span",
                            { staticClass: "az-text-primary font-semibold" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm
                                      .sumPL(
                                        _vm.operacoes.filter(function(a) {
                                          return a.operacao === "V"
                                        }),
                                        "movimentacao"
                                      )
                                      .replace("-", "")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    ),
                    _c("SimulatorOperationsTable", {
                      attrs: {
                        headers: _vm.headerCarteiraCompleta,
                        items: _vm.operacoes,
                        "group-by": _vm.modo,
                        "fixed-assets": _vm.novosAtivos
                      },
                      on: {
                        "save-notes": _vm.handleSaveNotes,
                        "fix-asset": _vm.fixarAtivo
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "v-scale-transition",
                [
                  !_vm.simulando
                    ? _c(
                        "ButtonAction",
                        { attrs: { color: "white" } },
                        [
                          _vm.simulacao.simulacao_salva ||
                          _vm.simulacao.expire_date
                            ? _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        height: "70px !important"
                                      },
                                      attrs: {
                                        color: "white",
                                        tile: "",
                                        width: "200",
                                        depressed: ""
                                      },
                                      on: { click: _vm.toPermanent }
                                    },
                                    [
                                      _c("icon-svg", {
                                        staticClass: "mr-3",
                                        attrs: {
                                          name: "mdi-clock",
                                          color: "primary"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-start"
                                        },
                                        [
                                          !_vm.simulacao.simulacao_salva
                                            ? _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "az-text-small"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Simulação será apagada "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.getDistanceDate(
                                                            _vm.simulacao
                                                              .expire_date
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _c("br"),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-primary mb-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Tornar permanente "
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "az-text-small"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Simulação permanente "
                                                    )
                                                  ]
                                                )
                                              ])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center mx-2" },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          "border-right":
                                            "1px solid rgba(0, 0, 0, 0.12)",
                                          height: "40px"
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.has_changes
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { height: "70px !important" },
                                  attrs: {
                                    color: "white",
                                    tile: "",
                                    depressed: "",
                                    loading: _vm.loadingPDF
                                  },
                                  on: { click: _vm.openSelectModelPDF }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center"
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-file-pdf-box",
                                          size: "18",
                                          color: "black"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm mt-1" },
                                        [_vm._v("Exportar")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          !_vm.has_changes
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { height: "70px !important" },
                                  attrs: {
                                    hidden: "",
                                    color: "white",
                                    tile: "",
                                    depressed: "",
                                    loading: _vm.loadingCliente
                                  },
                                  on: { click: _vm.sendClient }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center"
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-send",
                                          size: "18",
                                          color: "black"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm mt-1" },
                                        [_vm._v("Mobile")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.SHOW_WORKSPACE
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { height: "70px !important" },
                                  attrs: {
                                    color: "white",
                                    tile: "",
                                    depressed: ""
                                  },
                                  on: { click: _vm.openSendComponent }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center"
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-share-variant",
                                          size: "18",
                                          color: "black"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm mt-1" },
                                        [_vm._v("Workspace")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.restricoes_simulacao.tipo_simulador
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { height: "70px !important" },
                                  attrs: {
                                    color: "white",
                                    tile: "",
                                    depressed: ""
                                  },
                                  on: { click: _vm.toRestricoes }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center"
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-pencil",
                                          size: "18",
                                          color: "black"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm mt-1" },
                                        [_vm._v("Alterar")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.has_changes
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { height: "70px !important" },
                                  attrs: {
                                    color: "white",
                                    tile: "",
                                    depressed: ""
                                  },
                                  on: { click: _vm.simulateAgain }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center"
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-play-circle-outline",
                                          size: "18",
                                          color: "black"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm mt-1" },
                                        [_vm._v("Simular")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("v-scale-transition", [
                _vm.simulando
                  ? _c(
                      "div",
                      {
                        staticClass: "v-application",
                        staticStyle: {
                          position: "fixed",
                          bottom: "0",
                          width: "40%",
                          margin: "auto",
                          "margin-bottom": "20px",
                          "z-index": "3",
                          left: "0",
                          right: "0"
                        }
                      },
                      [
                        _c("LoadingStatus", {
                          attrs: {
                            loading: _vm.simulando,
                            load: _vm.simulacao.load,
                            status: _vm.simulacao.status
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
      _c("ModalPortfolioReviewEditNotes"),
      _c("ModalPesquisaHistorico", { attrs: { bus: _vm.busModal } }),
      _c("ModalTrocar", {
        attrs: {
          bus: _vm.busModal,
          fixados: [].concat(_vm.novosAtivos),
          "pl-total": _vm.pl_total
        }
      }),
      _c("ModalRestricoes"),
      _c("ModalAmpliarTabela")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }